// Auto-generated version file
// This file is updated automatically during builds
export const VERSION = {
  major: 1,
  minor: 0,
  patch: 0,
  build: process.env.REACT_APP_BUILD_NUMBER || '0',
  full: `1.0.0.${process.env.REACT_APP_BUILD_NUMBER || '0'}`
};